import { render, staticRenderFns } from "./ListCustomerServe.vue?vue&type=template&id=9590e9ac"
import script from "./ListCustomerServe.vue?vue&type=script&lang=js"
export * from "./ListCustomerServe.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ListCustomerServe.vue?vue&type=style&index=1&id=9590e9ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports